var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Shopping Basket Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Shopping-Basket-Black",
    fill: "#505050",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7395572,35.4166667 C16.442147,35.4166667 14.5833333,37.2916667 14.5833333,39.5833333 C14.5833333,41.875 16.442147,43.75 18.7395572,43.75 C21.0369674,43.75 22.9166667,41.875 22.9166667,39.5833333 C22.9166667,37.2916667 21.0369674,35.4166667 18.7395572,35.4166667 Z M6.25,6.25 L6.25,10.1388889 L10,10.1388889 L16.75,24.8972222 L14.21875,29.6611111 C13.91875,30.2055556 13.75,30.8472222 13.75,31.5277778 C13.75,33.6666667 15.4375,35.4166667 17.5,35.4166667 L40,35.4166667 L40,31.5277778 L18.2875,31.5277778 C18.025,31.5277778 17.81875,31.3138889 17.81875,31.0416667 L17.875,30.8083333 L19.5625,27.6388889 L33.53125,27.6388889 C34.9375,27.6388889 36.175,26.8416667 36.8125,25.6361111 L43.525,13.0166667 C43.675,12.7444444 43.75,12.4138889 43.75,12.0833333 C43.75,11.0138889 42.90625,10.1388889 41.875,10.1388889 L14.14375,10.1388889 L12.38125,6.25 L6.25,6.25 Z M37.4895572,35.4166667 C35.192147,35.4166667 33.3333333,37.2916667 33.3333333,39.5833333 C33.3333333,41.875 35.192147,43.75 37.4895572,43.75 C39.7869674,43.75 41.6666667,41.875 41.6666667,39.5833333 C41.6666667,37.2916667 39.7869674,35.4166667 37.4895572,35.4166667 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartGrey);
export default __webpack_public_path__ + "static/media/cart-grey.68103b79ab2e5aaeb82dd2394d1fe913.svg";
export { ForwardRef as ReactComponent };